import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import Seo from "../../components/Seo";
import { api, formatApiError } from "../../lib/api";
import { Logo } from "../../components/Logo";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("nl_token", data.access_token);
      toast.success(`Welcome back, ${data.user.name}`);
      navigate("/console");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1E1A17] flex items-center justify-center px-5">
      <Seo title="Admin Console | Nusadira Lembongan Villa" description="Private content management console for Nusadira Lembongan Villa." noindex />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-sm"
      >
        <div className="flex justify-center mb-8">
          <Logo />
        </div>
        <form
          data-testid="admin-login-form"
          onSubmit={submit}
          className="bg-[#26211D] border border-white/5 rounded-md p-8 space-y-5"
        >
          <h1 className="font-serif text-2xl text-[#F4EFEA] text-center">Admin Console</h1>
          <input
            data-testid="admin-login-email-input"
            type="email"
            required
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-[#1E1A17] border border-white/10 focus:border-[#9A7B66] rounded-xl px-4 py-3 text-sm text-[#F4EFEA] outline-none transition-colors"
          />
          <input
            data-testid="admin-login-password-input"
            type="password"
            required
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-[#1E1A17] border border-white/10 focus:border-[#9A7B66] rounded-xl px-4 py-3 text-sm text-[#F4EFEA] outline-none transition-colors"
          />
          <button
            data-testid="admin-login-submit-button"
            type="submit"
            disabled={loading}
            className="w-full py-3.5 rounded-full bg-[#9A7B66] hover:bg-[#826552] disabled:opacity-60 text-[#FBF9F5] text-[13px] font-sans font-semibold tracking-[0.12em] uppercase transition-colors"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
